import type { DataRepository } from "../types";
import { DemoRepository } from "./demo-repository";
import { SupabaseRepository } from "./repository";
import { configured, demoMode, supabase, workspaceId } from "./supabase";

export function createRepository(): DataRepository | null {
  if (demoMode) return new DemoRepository();
  if (configured && supabase) return new SupabaseRepository(supabase, workspaceId);
  return null;
}
